import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/incidencias-subcategorias';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * Get Subcategorias De Incapacidades
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSubcategoriasDeIncapacidades = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Subcategoria De Incapacidades
 * @params {number} id
 * @returns {Promise<object|null>};
 */
export const getSubcategoriaDeIncapacidades = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Subcategoria De Incapacidades
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSubcategoriaDeIncapacidades = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Subcategoria De Incapacidades
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSubcategoriaDeIncapacidades = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Subcategoria De Incapacidades
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteSubcategoriaDeIncapacidades = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
